// UI strings for Kielioppi (the grammar reference page), its links from lessons and the
// dictionary, Finnish (default) and English side by side. The topic texts themselves are in
// app/src/grammar/*.mdx, in both languages.
import { defineArea } from '../area';

export const grammarFi = {
  title: 'Kielioppi',
  toc: 'Sisällys',
  loading: 'Ladataan kielioppia…',
  loadFailed: 'Kieliopin lataaminen ei onnistunut. Yritä uudelleen, kun yhteys toimii.',
  lessons: 'Oppitunnit',
  /** Lesson header: "Kielioppi: Sijat". */
  inGrammar: 'Kielioppi',
  /** Dictionary entry under the inflection table: "Lue lisää: Sijat · Deklinaatiot". */
  readMore: 'Lue lisää',
  unsure: 'Osan sanoista vartalon ja päätteen rajaa ei ole varmistettu, joten ne näytetään kokonaisina ilman saumaa.',
  forms: 'Muodot',
  word: 'Sana',
  form: 'Muoto',
  /** One § per page (layout v2): the margin's topics of this §, the next §, the § last read. */
  inThis: 'Tässä luvussa',
  next: (n: number, title: string) => `Seuraavaksi: § ${n} ${title}`,
  continueAt: (n: number, title: string) => `Jatka: § ${n} ${title}`,
};

export const grammarEn: typeof grammarFi = {
  title: 'Grammar',
  toc: 'Contents',
  loading: 'Loading the grammar…',
  loadFailed: 'The grammar could not be loaded. Try again when you are online.',
  lessons: 'Lessons',
  inGrammar: 'Grammar',
  readMore: 'Read more',
  unsure: 'For some of these words the split into stem and ending is not confirmed, so they are shown whole, without a seam.',
  forms: 'Forms',
  word: 'Word',
  form: 'Form',
  inThis: 'In this section',
  next: (n, title) => `Next: § ${n} ${title}`,
  continueAt: (n, title) => `Continue: § ${n} ${title}`,
};

// Messages.grammar (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('grammar', grammarFi, grammarEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof grammarFi> {}
}
